<template>
  <v-container>
     <v-card  class="mx-auto"
    
    outlined>
     <v-card-text>
     <h1 class="text-center ma-5" >Family Tree Worksheet</h1>
     <!-- <p>  <v-btn @click='downloadPDF' rounded color="primary" dark>Download PDF <v-icon class='ml-1' medium>mdi-download</v-icon></v-btn></p>  -->
     <p class="text-center ma-10 font-weight-regular title">You and your close relatives (parents, siblings, children) share approximately 50% of your DNA
(nature), but most families also share environments and environment risk factors for many health
conditions (nurture). Our current understanding of nature and nurture in whether someone will
develop many medical conditions is incomplete. However, research about our genes is evolving,
as is our ability to determine if someone is predisposed to a particular medical concern because of
their genes. This is one of the reasons why My Genetic Trust was developed.

</p>

<v-row class='ma-4'>
    <v-flex
                          xs12
                          sm12>
         <p class="text-center mt-6 font-weight-regular title">
    One of the most useful tools in genetic healthcare is a good record of family health history. The
purpose of this worksheet is to help you gather information about your medical and family health
history. This printed worksheet, along with the Family History Collection Guide and Medical
Record Collection Guide, can help you accurately fill out your Genetic Trust online.
</p>
       
    </v-flex>
</v-row>

<div class='ma-10'>
 <li  class='font-weight-regular title'>Please include all of your relatives who are related to you by blood..
</li>
<li  class='font-weight-regular title'>Please consult with your family members to increase the accuracy of health
information. <a href='https://docs.google.com/document/d/1P7UX9mnTv8bIuSLQvMbPnRXYD-3fHBBR53G6bbUpiAQ/edit' target='blank'>Here</a> is an email template we will attached to the email as well as a link to the electronic version of the family tree worksheet.</li>
</div>
<v-row>
    <v-col cols="12" >
  <v-text-field class='ml-5 mr-5' v-model='inviteEmail'
            label="Please enter the email address of the family member you'd like to invite"
          ></v-text-field>
          <v-btn @click='sendInvite' :disabled='!inviteEmail' class='ml-5 mr-5' tile outlined color="success">
      <v-icon left>mdi-send</v-icon> Invite
    </v-btn>
    </v-col>
   
</v-row>



<p class="subtitle-2 text-center"><img  src="../assets/staticAsset/Fam4.jpg" /></p>

 
 </v-card-text>
     </v-card>
  </v-container>
</template>

<script>
import { postReq} from '../helper/firestore'
export default {
  data() {
    return{
      inviteEmail : null,
    }
  },
  methods : {
    sendInvite(){
           postReq(process.env.VUE_APP_ROOT_API_URL +'/user/sendFamilytreeInvite',{
             inviteEmail : this.inviteEmail
           },result=>{
                this.items = result.data
                if(result.data.length > 0) {
                  this.empty = false;
                }else{
                  this.empty = true;
                }
      })
    },
    downloadPDF(){
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.download = name;
      a.target = "blank";
      a.href = "https://storage.googleapis.com/genetictrust-dev.appspot.com/public/My%20Genetic%20Trust%20Family%20Tree%20Worksheet.pdf";
      a.click();
    }
  }
}
</script>

<style>

</style>